import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routes } from '@/routes'

// A data router (not <BrowserRouter>) -- that's what unlocks
// `viewTransition` on links, which powers the page transitions.
const router = createBrowserRouter(routes)

function App() {
  return <RouterProvider router={router} />
}

export default App
